import React, {useEffect, useState} from 'react';
import {moneyProduct, roundMoney} from '../utils/money';
import {useLocation, useNavigate} from "react-router-dom";
import { Button, Container, Row, Col} from "react-bootstrap";
import {useUser} from "../../UserContext";
import {fetchCurrentStore} from "../../api/api";
const Receipt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {cart, discount, selectedCustomer, total, paymentMethod, amountPaid, changeToGive,
        vatAmount, created_at} = location.state;
    const { user } = useUser();
    const [store, setStore] = useState(null);

    useEffect(() => {
        fetchCurrentStore()
            .then(setStore)
            .catch((error) => console.error("Unable to load receipt store details", error));
    }, []);

    const getLineSubtotal = (item) => moneyProduct(item.price, item.quantity);
    const getLineDiscount = (item) => Number(item.quantity_discount ?? 0) || 0;
    const getDiscountedLineSubtotal = (item) => roundMoney(Number(item.discounted_subtotal ?? Math.max(0, getLineSubtotal(item) - getLineDiscount(item))) || 0);
    const quantityDiscountTotal = cart.reduce((sum, item) => sum + getLineDiscount(item), 0);
    const formatReceiptDate = (value) => {
        if (!value) return 'N/A';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;

        const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Africa/Nairobi',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        }).formatToParts(date).reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});

        return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`;
    };

    const branchName = store?.name || 'Main';
    const phoneNumber = store?.receipt_phone_number || '0789525313';
    const receiptArea = store?.receipt_area || 'Ngong Town, Kajiado';
    const paymentDetails = store?.receipt_payment_details || '';

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <div className="text-center mb-4">
                        <h2>BEEQASI WHOLESALE & RETAIL</h2>
                        <h4>Branch: {branchName}</h4>
                        <h3>Receipt</h3>
                        <p>Date: {formatReceiptDate(created_at)}</p>
                        <p>Phone: {phoneNumber}</p>
                        <p>Mail: beeqasimails@gmail.com</p>
                        <p>Location: {receiptArea}</p>
                        <p>Served by: {user.username}</p>
                    </div>
                    <hr/>
                    <div>
                        <Row className="mb-2">
                            <Col xs={6}><strong>Item</strong></Col>
                            <Col xs={3} className="text-right"><strong>Qty</strong></Col>
                            <Col xs={3}><strong>Price</strong></Col>
                        </Row>
                        {cart.map((item, index) => (
                            <React.Fragment key={index}>
                                <Row className="mb-2">
                                    <Col xs={6}>
                                        {item.name}
                                        {/*{item.isAlternativeUnit ? ` ${item.unit_name || item.unit_abbreviation || 'Unit'}` : ''}*/}
                                        {/*check if unit_id of the alternative unit exists*/}
                                        {item.unit_id && item.unit_name ? ` ${item.unit_name}` : ""}
                                    </Col>
                                    <Col xs={3} className="text-right">{item.quantity} x</Col>
                                    <Col xs={3}>Ksh. {parseFloat(item.price).toFixed(2)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs={9}></Col>
                                    <Col xs={3}>Ksh. {getDiscountedLineSubtotal(item).toFixed(0)}</Col>
                                </Row>
                                {getLineDiscount(item) > 0 && (
                                    <Row className="mb-2 text-success">
                                        <Col xs={9}>{item.quantity_discount_reason || 'Quantity discount'}</Col>
                                        <Col xs={3}>- Ksh. {getLineDiscount(item).toFixed(2)}</Col>
                                    </Row>
                                )}
                                <hr/>
                            </React.Fragment>
                        ))}
                        <Row className="mb-2">
                            <Col xs={9}>Subtotal (VAT included): </Col>
                            <Col xs={3}><strong>Ksh. {cart.reduce((sum, item) => sum + getDiscountedLineSubtotal(item), 0).toFixed(0)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Included VAT 16%: </Col>
                            <Col xs={3}><strong>Ksh. {vatAmount.toFixed(2)}</strong></Col>
                        </Row>
                        {discount > 0 && (
                            <Row className="mb-2">
                                <Col xs={9}>Discount: </Col>
                                <Col xs={3}>- Ksh. {discount.toFixed(2)}</Col>
                            </Row>
                        )}
                        {quantityDiscountTotal > 0 && (
                            <Row className="mb-2 text-success">
                                <Col xs={9}>Quantity Discount: </Col>
                                <Col xs={3}>- Ksh. {quantityDiscountTotal.toFixed(2)}</Col>
                            </Row>
                        )}
                        <Row className="mb-2">
                            <Col xs={9}>Total: </Col>
                            <Col xs={3}><strong>Ksh. {total.toFixed(0)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Payment Method: </Col>
                            <Col xs={3}>{paymentMethod}</Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Amount Paid: </Col>
                            <Col xs={3}><strong>Ksh. {amountPaid}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Change: </Col>
                            <Col xs={3}><strong>Ksh. {changeToGive.toFixed(2)}</strong></Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={9}>Customer: </Col>
                            <Col xs={3}>{selectedCustomer.name || 'Walk-in'}</Col>
                        </Row>
                    </div>
                    <div className="text-center mb-4">
                        {paymentDetails && <h2>{paymentDetails}</h2>}
                        <p>Thank you for shopping with us!</p>
                    </div>
                    <hr/>
                    <div className="text-center mt-4">
                        <Button variant="primary" onClick={() => navigate('/pos')}>
                            Back to POS
                        </Button>
                    </div>
                    {/*<div className="text-center mt-4">*/}
                    {/*    <Button variant="success" onClick={() => window.print()}>Print Receipt</Button>*/}
                    {/*</div>*/}
                </Col>
            </Row>
        </Container>
    );
};

export default Receipt;
